/** Apparel size encoded as the final hyphen segment of an RSV SKU. */

export type ApparelSize = 'XS' | 'S' | 'M' | 'L' | 'XL';

const SIZE_BY_TOKEN = {
  XS: 'XS',
  S: 'S',
  SM: 'S',
  M: 'M',
  MED: 'M',
  L: 'L',
  LG: 'L',
  XL: 'XL',
} as const;

type SizeToken = keyof typeof SIZE_BY_TOKEN;

const MILLIMETER_TOKEN = /^\d+(?:\.\d+)?MM$/;

function isSizeToken(token: string): token is SizeToken {
  return Object.prototype.hasOwnProperty.call(SIZE_BY_TOKEN, token);
}

/**
 * Read XS, S, M, L, or XL from the last hyphen segment of an RSV SKU.
 * Interior letters are material or role codes. XXL and other endings are ignored.
 * A trailing M after a millimeter token is connector gender. JUTE.KIT LG/MD are kit tiers.
 */
export function apparelSizeFromSku(sku: string | null | undefined): ApparelSize | null {
  const normalized = String(sku ?? '').trim().toUpperCase();
  if (!normalized.startsWith('RSV-')) {
    return null;
  }

  const parts = normalized.split('-');
  const last = parts[parts.length - 1] ?? '';
  const prev = parts[parts.length - 2] ?? '';
  if (last === 'M' && MILLIMETER_TOKEN.test(prev)) {
    return null;
  }
  if ((last === 'LG' || last === 'MD') && normalized.includes('JUTE.KIT')) {
    return null;
  }
  if (!isSizeToken(last)) {
    return null;
  }
  return SIZE_BY_TOKEN[last];
}
